import React from 'react';
import {useSettingsState} from './settings';
import useQuery from '../utilities/use-query';

export const useIsTablet = () => {
    const {defaultMode} = useSettingsState();
    const {mode = defaultMode} = useQuery();
    const isTablet = mode && mode === 'tablet';
    return isTablet;
};

const HideForTabletMode = ({children}) => {
    const isTablet = useIsTablet();
    return (
        <>
            {!isTablet && children}
        </>
    );
};

export default React.memo(HideForTabletMode);